import { UserAttribute } from './userattribute';

export class SkillResponse {
    public skillTypeId: number = 0;
    public skillTypeName: string = '';
    public skillTypeDesc: string = '';
    public status: string = '';
    public industryVerticalName : string = '';
    public userAttributes: UserAttribute[] = [];
}